import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'

@ngCore.Component({
  imports: [ds.overlay.attached.Component],
  selector: 'atn-check-in-mood-pop-up',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.summit.checkIn.Feature} */
  public readonly checkInFeature = ngCore.inject(state.summit.checkIn.Feature)
}
